import React from 'react';
import MUIDataTable from 'mui-datatables';
import { format } from 'date-fns';
import "../../common/css/protagonistMUIDatatable.css";

const InvestorDetails = ({ investors }) => {
    const insightsData = JSON.parse(investors.insights);
    console.log(insightsData);
  
    const formatData = (data) => {
        const insightsData = JSON.parse(data.insights);
        const investors = insightsData.content;
      
        if (!Array.isArray(investors)) {
          return [];
        }
      
        return investors.map(investorObj => {
            if (!investorObj || !investorObj.rounds) {
                return [];
            }
            
            return investorObj.rounds.map(round => {
                if (!round || !round.roundInfo || !round.roundInfo.amount || !round.roundInfo.number) {
                    return null;
                }
                
                return {
                    investorName: investorObj.investor ? investorObj.investor.name : null,
                    roundNumber: round.roundInfo.number || null,
                    roundDate: round.roundInfo.date || null,
                    investmentRound: round.roundInfo.type || null,
                    roundAmount: round.roundInfo.amount.amount || null,
                    roundStatus: round.roundStatus || null,
                };
            }).filter(round => round);  // filter out null rounds
        }).flat();
      };
      
    

  const data = formatData(investors);

  const customDateRender = (value) => {
    const investmentDate = new Date(value);
    const localDate = new Date(investmentDate.getTime() - investmentDate.getTimezoneOffset() * 60000);
    return format(localDate, 'do MMM, yyyy');
  };

  const customValueRender = (value) => {
    return Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  const columns = [
    { name: 'investorName', label: 'Investor Name' },
    { name: 'roundDate', label: 'Investment Date', 
      options: { customBodyRender: customDateRender, } 
    },
    { name: 'roundNumber', label: 'Round Number' },
    { name: 'investmentRound', label: 'Investment Round' },
    { name: 'roundAmount', label: 'Total Raised in Round', 
      options: { customBodyRender: customValueRender, } 
    },
    { name: 'roundStatus', label: 'Investment Status' },
  ];

  const options = {
    filter: false,
    filterType: 'dropdown',
    responsive: 'standard',
    serverSide: false,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    selectableRows: 'none',
    expandableRows: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    customToolbarSelect: () => {},
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'medium',
      };
    },
    textLabels: {
      body: {
        noMatch: 'Sorry, no matching records found',
      },
    },
    sortOrder: {
      name: 'roundDate',
      direction: 'desc'
    }
  };

  return (
    <div className="table-container">
      <MUIDataTable
        data={data}
        columns={columns}
        options={options}
        className="protMUIDatatable"
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default InvestorDetails;
